import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import Wordmark from "@/components/Wordmark";

const SetPassword = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // Supabase auto-handles the hash and creates a session for invite/recovery links.
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) setReady(true);
    });
    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) setReady(true);
    });
    return () => sub.subscription.unsubscribe();
  }, []);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password.length < 8) return toast.error("Password must be at least 8 characters");
    if (password !== confirm) return toast.error("Passwords do not match");
    setSubmitting(true);
    const { error } = await supabase.auth.updateUser({ password });
    setSubmitting(false);
    if (error) return toast.error(error.message);
    toast.success("Password set! Welcome.");
    navigate("/dashboard");
  };

  return (
    <div className="min-h-screen bg-gradient-warm flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-card rounded-[1.5rem] shadow-bold p-8">
        <Link to="/" className="flex justify-center mb-6">
          <Wordmark size="md" />
        </Link>
        <h1 className="font-display text-3xl text-center">Set your password</h1>
        <p className="text-sm text-muted-foreground text-center mt-2">
          Welcome — choose a password to access your athlete dashboard.
        </p>

        {!ready ? (
          <p className="mt-8 text-center text-sm text-muted-foreground">
            Verifying invite link…
          </p>
        ) : (
          <form onSubmit={submit} className="space-y-4 mt-6">
            <div>
              <label className="text-xs font-semibold uppercase tracking-wider">New password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={8}
                maxLength={72}
                className="w-full mt-1 px-4 py-3 rounded-xl bg-muted border border-border focus:outline-none focus:ring-2 focus:ring-primary"
              />
            </div>
            <div>
              <label className="text-xs font-semibold uppercase tracking-wider">Confirm password</label>
              <input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
                minLength={8}
                maxLength={72}
                className="w-full mt-1 px-4 py-3 rounded-xl bg-muted border border-border focus:outline-none focus:ring-2 focus:ring-primary"
              />
            </div>
            <button
              type="submit"
              disabled={submitting}
              className="w-full py-3 rounded-full bg-primary text-primary-foreground font-semibold hover:bg-secondary transition-colors disabled:opacity-50"
            >
              {submitting ? "..." : "Set password & continue"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default SetPassword;
